import { useTranslation } from 'react-i18next';

function OrderedList() {
  const { t } = useTranslation();
  const bankIdItems = [
    { title: t('bank_id:box_row_1') },
    { title: t('bank_id:box_row_2') },
    { title: t('bank_id:box_row_3') },
  ];
  return (
    <div className="p-5 bg-background-accent rounded-md w-full">
      <p className="font-semibold mb-4">{t('bank_id:box_title')}</p>
      <ol className="flex flex-col gap-4">
        {bankIdItems.map(({ title }, index) => (
          <li key={title} className="flex gap-4">
            <div className="flex justify-center items-center border-2 border-primary rounded-full h-7 w-7 flex-shrink-0 bg-background text-primary font-semibold">
              {index + 1}
            </div>
            <div>{title}</div>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default OrderedList;
